module.exports = __webpack_public_path__ + "static/media/front-desk.135aee65.svg";